import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from "../utility/crypto";

const option = {
  autoClose: 1000,
};

const defaultHeaders = {
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  Expires: "0",
};

export function apiClient({
  url,
  data = {},
  method = "POST",
  headers = {},
  noHeaders,
  isToast,
  encrypt = false,
  decrypt = false,
  ...rest
}: any) {
  return new Promise((resolve, reject) => {
    const payload =   data;
    axios({
      method,
      url,
      headers: {
        ...(noHeaders ? {} : defaultHeaders),
        ...headers,
      },
      data: payload,
      ...rest,
    })
      .then((res: any) => {
        const result =
          decrypt && res?.data?.encryptedPayload
            ? decryptData(res.data.encryptedPayload)
            : res.data;
        resolve(result);
        // resolve(res.data);
        if (isToast) toast.success(result?.message, option);
      })
      .catch((err: any) => {
        const result =
          decrypt && err?.response?.data?.encryptedPayload
            ? decryptData(err?.response?.data?.encryptedPayload)
            : err?.response?.data;
        const error = { ...err, response: { ...err?.response, data: result } };
        if (error.response && error.response.data.message) {
          reject(error.response.data.error);
          if (error.response.data.statusCode === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            localStorage.removeItem("emailId");
            localStorage.removeItem("lastName");
            toast.error("Please Reload the Page and Login Again", option);
          } else {
            toast.error(error.response.data.message, option);
          }
        } else {
          reject(error);
        }
      });
  });
}
